import { render } from "./ViewOverlayTemplate.vue?vue&type=template&id=6c5b112f&scoped=true"
import script from "./ViewOverlayTemplate.vue?vue&type=script&lang=js"
export * from "./ViewOverlayTemplate.vue?vue&type=script&lang=js"

import "./ViewOverlayTemplate.vue?vue&type=style&index=0&id=6c5b112f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5b112f"]])

export default __exports__